import { computed, Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag, FeatureFlagService } from '@services/feature-flag.service'

@Directive({
  selector: '[albertFeatureFlagDirective]',
})
/**
 * Directive for conditional rendering based on feature flags according to https://www.flagsmith.com/blog/angular-feature-flag.
 * Requires the environment variables `flagsmithApiUrl` and `flagsmithEnvironmentId` to be set.
 * Example usage:
 * <section *appFeatureFlag="'search'; value: false">
 */
export class FeatureFlagDirective {
  public readonly albertFeatureFlagDirective = input<FeatureFlag>();
  public readonly albertFeatureFlagDirectiveValue = input<boolean>(true);
  public readonly featureFlagService = inject(FeatureFlagService);

  // Reference to the template the directive is attached to
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainerRef = inject(ViewContainerRef);

  constructor() {
    effect(() => {
      const isOn = computed(
        () =>
          this.featureFlagService.featureFlags()[this.albertFeatureFlagDirective()!] ===
          this.albertFeatureFlagDirectiveValue()
      );
      if (isOn()) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }
}
